"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticIpFormViewSubSteps = exports.defaultWizardSteps = exports.wizardStepNames = void 0;
exports.wizardStepNames = {
    'cluster-details': 'Cluster details',
    operators: 'Operators',
    'host-discovery': 'Host discovery',
    'static-ip-yaml-view': 'Static network configurations',
    'static-ip-network-wide-configurations': 'Network-wide configurations',
    'static-ip-host-configurations': 'Host specific configurations',
    storage: 'Storage',
    networking: 'Networking',
    'custom-manifests': 'Custom manifests',
    review: 'Review and create',
    'credentials-download': 'Download credentials',
};
exports.defaultWizardSteps = [
    'cluster-details',
    'operators',
    'host-discovery',
    'storage',
    'networking',
    'review',
];
exports.staticIpFormViewSubSteps = [
    'static-ip-network-wide-configurations',
    'static-ip-host-configurations',
];
//# sourceMappingURL=constants.js.map